import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "checkbox-label" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelConsultationDialog',
  props: {
    open: { type: Boolean },
    orderItemId: { type: Function }
  },
  emits: ["close", "done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const reason = ref('');
const refund = ref(false);
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        // TODO(v2-cutover): /admin-api/consultation-bookings/<id>/cancel/ was
        // removed with the ConsultationBooking model. V2 cancel = commerce
        // Reservation cancel (BespokeCommerceReservationsViewSet) + Conference
        // cancel (status LATE_CANCELED) + Order-level refund. Re-point at
        // POST /admin-api/reservations/<reservation_id>/cancel/ resolved from the
        // OrderItem; the legacy hold.secure_deal refund path is gone (payment now
        // lives on the Order). Requires BE coordination for orderItemId ->
        // reservation resolution and the refund leg.
        await request({
            method: 'post',
            url: `/admin-api/reservations/${props.orderItemId()}/cancel/`,
            data: { reason: reason.value, refund: refund.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    open: _ctx.open,
    class: "action-dialog"
  }, [
    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Отменить личную сессию", -1)),
    _createElementVNode("label", null, [
      _cache[3] || (_cache[3] = _createTextVNode("Причина отмены ")),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event)),
        rows: "3"
      }, null, 512), [
        [_vModelText, reason.value]
      ])
    ]),
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refund).value = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, refund.value]
      ]),
      _cache[4] || (_cache[4] = _createTextVNode(" Вернуть средства клиенту "))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn--danger",
        disabled: busy.value,
        onClick: submit
      }, _toDisplayString(busy.value ? 'Отменяю…' : 'Отменить личную сессию'), 9, _hoisted_4),
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, "Назад")
    ])
  ], 8, _hoisted_1))
}
}

})